/**
 * Runtime detector for booking-only hosts (`meet.ahoy.ai`, etc.).
 *
 * Used to mount a host-specific router and skip allauth init on hosts that
 * serve only the public scheduling/booking UI, not the full app.
 */

export const BOOKING_HOSTS = ['meet.ahoy.ai', 'meet-staging.ahoy.inc'] as const;

function getDefaultHostname(): string {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '';
}

export function isBookingHost(hostname?: string): boolean {
  const host = hostname !== undefined ? hostname : getDefaultHostname();
  return (BOOKING_HOSTS as readonly string[]).includes(host);
}

export const BOOKING_ROUTE_PATHS = {
  shortCodeMeeting: '/m/:shortCode',
  bookBySlug: '/book/:username/:slug',
  scheduleBySlug: '/schedule/:username/:slug',
  cancelBooking: '/booking/:cancelToken/cancel',
  rescheduleBooking: '/booking/:cancelToken/reschedule',
  globalSlug: '/:globalSlug',
  gSlug: '/g/:globalSlug',
} as const;
